const useCSRFToken = (): string => {
  const csrfToken =
    // @ts-expect-error fdjskafjfd f
    document.getElementsByName('csrfmiddlewaretoken')?.[0].value;
  return csrfToken;
};

export default useCSRFToken;
